import * as StatusSearchActions from "./search.actions";
import { createReducer, on } from "@ngrx/store";
import { recursive as mergeRecursive } from "merge";
import { SearchState } from "./search.state";

const initialState: SearchState = {
    activeTab: "Contact",
    contactSearch: {
        initialized: false,
        searchTerm: "",
        loading: false,
        updatingFilters: false,
        rows: [],
        filters: {
            department: { items: [], collapsed: true },
            jobRole: { items: [], collapsed: true },
            employeeRange: { items: [], collapsed: true },
            industry: { items: [], collapsed: true },
            level: { items: [], collapsed: true },
            revenueRange: { items: [], collapsed: true },
            title: { items: [], collapsed: true },
            name: { items: [], collapsed: true },
            companyName: { items: [], collapsed: true },
            location: { items: [], collapsed: true },
            state: { items: [], collapsed: true },
            city: { items: [], collapsed: true },
            country: { items: [], collapsed: true },
            website:{items: [], collapsed: true}
        },
        filteringPath: [],
        sorting: {
            asc: false,
            field: "companyName",
        },
        pager: {
            pageSize: 50,
            pageNumber: 1,
            totalElements: 0,
            totalPages: 0,
        },
        searchOptions: {
            showInactiveCompanies: false,
            hideMyOwnedCompanies: false,
            showOnlyDirectDials: false,
        }
    },
    companySearch: {
        initialized: false,
        searchTerm: "",
        loading: false,
        updatingFilters: false,
        rows: [],
        filters: {
            countryState: { items: [], collapsed: true },
            companyName: { items: [], collapsed: true },
            employeeRange: { items: [], collapsed: true },
            industry: { items: [], collapsed: true },
            ownership: { items: [], collapsed: true },
            revenueRange: { items: [], collapsed: true },
            state: { items: [], collapsed: true },
            city: { items: [], collapsed: true },
            location: { items: [], collapsed: true },
            country: { items: [], collapsed: true },
            website:{items: [], collapsed: true}
        },
        filteringPath: [],
        sorting: {
            asc: false,
            field: "companyName",
        },
        pager: {
            pageSize: 50,
            pageNumber: 1,
            totalElements: 0,
            totalPages: 0,
        },
        searchOptions: {
            showInactiveCompanies: false,
            hideMyOwnedCompanies: false,
            showOnlyDirectDials: false,
        }
    },
};

export const SearchReducer = createReducer(
    initialState,
    on(StatusSearchActions.ExtendStateAction, (state, { newState }) => ({ ...state, ...newState })),
    on(StatusSearchActions.MergeStateAction, (state, { newState }) => mergeRecursive(true, state, newState)),
);
